module.exports = __webpack_public_path__ + "static/media/Bytt-tutorial-1.afe50407.mp3";